<template>
  <b-row>
    <b-col
      v-for="item in servers"
      :key="item.id"
      :lg="rowitems"
      md="12"
      :class="{ 'noSelectable': computing }"
    >
      <b-card
        class="servercard"
        :class="{ 'selected': item.selected }"
        @click="changeSelected(item)"
      > 
        <server :data="item" />
      </b-card>
    </b-col>
  </b-row>
</template>
<script>
import {
  BRow,
  BCol,
  BCard,
} from 'bootstrap-vue'
import store from '@/store/index'
import axios from 'axios'
import server from './components/server.vue'

const { url, port, auth } = store.state.appConfig.api
const headers = {
  authentication: auth,
  'Content-Type': 'application/json',
}
export default {
  components: {
    server,
    BRow,
    BCol,
    BCard,
  },
  props: {
    servers: {
      required: true,
      type: [String, Object, Array],
    },
    computing: {
      required: true,
      type: Boolean,
    },
    type: {
      required: false,
      type: String,
      default: 'processing',
    },
  },
  computed: {
    rowitems() {
      let cols = 4
      if (this.type === 'downstream' ) {
        cols = 3
      }
      return cols
    },
  },
  methods: {
    changeSelected(item) {
      
      if (!this.computing && this.type != 'viewers') {
        const { id } = this.$route.params
        const newServer = (item.selected) ? '' : item.id
        const { type } = this
        const data = JSON.stringify({ newServer, type })
        console.log(data)
        if (this.type === 'downstream') {
          axios.put(`${url}:${port}/downstream-server/${id}`, data, { headers })
        } 
        else if (this.type === 'viewers') {
          axios.put(`${url}:${port}/viewers-server/${id}`, data, { headers })
        }
        else {
          axios.put(`${url}:${port}/default-server/${id}`, data, { headers })
        }
      }
      else if(this.type === 'viewers'){
        const { id } = this.$route.params
        const newServer = item.id
        const { type } = this
        const data = JSON.stringify({ newServer, type })
        axios.put(`${url}:${port}/viewers-server/${id}`, data, { headers })
        

      }
    },
  },
}
</script>
<style>
.card .card.servercard{
    box-shadow: 5px 5px 15px 5px rgba(0,0,0,0.10)!important;
    border: 1px solid rgba(0, 0, 0, 0.10);
    cursor: pointer;
}
 .card .noSelectable .card.servercard{
  cursor: not-allowed!important;
}
.card.servercard .card-body {
    padding: 0.5rem 1.5rem 1.5rem;
}
.card .card.servercard.selected{
  background: #f3f9f9;
    border: 1px solid #028380 !important;
}
</style>
